import { countries } from "./countries";
import { specialties } from "./specialties";

export { countries, specialties };

export const MOBILE_OSES = {
  IOS: "iOS",
  ANDROID: "Android",
};

export const RouteAccessState = {
  public: "PUBLIC",
  loggedInOnly: "LOGGED_IN_ONLY",
  loggedOutOnly: "LOGGED_OUT_ONLY",
  AdminOnly: "ADMIN_ONLY",
};

export const collectionFormModalTriggerSources = {
  ADD_TO_COLLECTION_MODAL: "addToCollectionModal",
  COLLECTIONS_PAGE: "collectionsPage",
};

export default {
  countries,
  specialties,
  MOBILE_OSES,
  collectionFormModalTriggerSources,
};



// WEBPACK FOOTER //
// ./src/constants/index.js